const IT_STORE_PAGE = {
    pageTitle: {
        ja: "\u30D1\u30BD\u30B3\u30F3\u30FBIT\u6A5F\u5668\u8CA9\u58F2 | \u682A\u5F0F\u4F1A\u793ENAPIRE",
        en: "PC & IT Equipment Store | NAPIRE Inc."
    },
    metaDescription: {
        ja: "\u5B66\u751F\u30FB\u500B\u4EBA\u30FB\u500B\u4EBA\u4E8B\u696D\u4E3B\u30FB\u6CD5\u4EBA\u306E\u304A\u5BA2\u69D8\u5411\u3051\u306B\u3001\u30D1\u30BD\u30B3\u30F3\u3001\u30E2\u30CB\u30BF\u30FC\u3001\u30D7\u30EA\u30F3\u30BF\u30FC\u3001\u5468\u8FBA\u6A5F\u5668\u3092\u6BD4\u8F03\u3057\u3066\u9078\u3079\u308B\u682A\u5F0F\u4F1A\u793ENAPIRE\u306EIT\u30B9\u30C8\u30A2\u3067\u3059\u3002",
        en: "Compare PCs, monitors, printers, and accessories selected by NAPIRE for students, individuals, sole proprietors, and companies."
    },
    metaKeywords: {
        ja: "NAPIRE,IT\u6A5F\u5668,\u5B66\u751F\u5411\u3051\u30D1\u30BD\u30B3\u30F3,\u500B\u4EBA\u5411\u3051\u30D1\u30BD\u30B3\u30F3,\u6CD5\u4EBA\u5411\u3051IT\u6A5F\u5668,\u30E2\u30CB\u30BF\u30FC\u8CA9\u58F2,\u30D7\u30EA\u30F3\u30BF\u30FC\u8CA9\u58F2,\u5468\u8FBA\u6A5F\u5668,\u8CFC\u5165\u76F8\u8AC7,\u5546\u54C1\u6BD4\u8F03",
        en: "NAPIRE,IT equipment,student PC,personal PC,business IT equipment,monitor sales,printer sales,accessories,purchase inquiry,comparison"
    },
    heroLabel: {
        ja: "NAPIRE IT Store",
        en: "NAPIRE IT Store"
    },
    heroTitle: {
        ja: "\u5B66\u3073\u306B\u3082\u3001\u4ED5\u4E8B\u306B\u3082\u3002\n\u6BD4\u3079\u3066\u3001\u9078\u3079\u308B\u3002",
        en: "For study and work.\nCompare and choose."
    },
    heroLead: {
        ja: "\u5B66\u751F\u30FB\u500B\u4EBA\u30FB\u500B\u4EBA\u4E8B\u696D\u4E3B\u30FB\u6CD5\u4EBA\u306E\u304A\u5BA2\u69D8\u3078\u3002\u6388\u696D\u30FB\u5C31\u6D3B\u30FB\u5728\u5B85\u30EF\u30FC\u30AF\u30FB\u30AA\u30D5\u30A3\u30B9\u5C0E\u5165\u307E\u3067\u3001\u7528\u9014\u3068\u4E88\u7B97\u3067\u9078\u3079\u308BIT\u6A5F\u5668\u3092\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u30021\u70B9\u304B\u3089\u3054\u8CFC\u5165\u3092\u76F8\u8AC7\u3067\u304D\u3001\u8868\u793A\u4FA1\u683C\u306F\u7A0E\u8FBC\u3067\u3059\u3002",
        en: "For students, individuals, sole proprietors, and companies. Find IT equipment for classes, job hunting, remote work, and offices. Inquiries are welcome from a single item; listed prices include tax."
    },
    heroCta: {
        ja: "\u5546\u54C1\u3092\u6BD4\u8F03\u3059\u308B",
        en: "Compare products"
    },
    heroCta2: {
        ja: "\u8CFC\u5165\u30FB\u898B\u7A4D\u3092\u76F8\u8AC7",
        en: "Ask about purchase or a quote"
    },
    countLabel: {
        ja: "\u53B3\u9078\u5546\u54C1",
        en: "Selected products"
    },
    productsLabel: {
        ja: "Selected equipment",
        en: "Selected equipment"
    },
    productsTitle: {
        ja: "\u7528\u9014\u3068\u4E88\u7B97\u3067\u9078\u3079\u308B36\u5546\u54C1",
        en: "36 products for different needs and budgets"
    },
    productsLead: {
        ja: "\u6388\u696D\u30FB\u5C31\u6D3B\u30FB\u81EA\u5B85\u4F5C\u696D\u30FB\u4ED5\u4E8B\u74B0\u5883\u306B\u4F7F\u3048\u308BPC\u3001\u30E2\u30CB\u30BF\u30FC\u3001\u30D7\u30EA\u30F3\u30BF\u30FC\u3001\u5468\u8FBA\u6A5F\u5668\u3092\u6A2A\u65AD\u3057\u3066\u6BD4\u8F03\u3067\u304D\u307E\u3059\u3002\u5E02\u5834\u306E\u8CA9\u58F2\u4FA1\u683C\u3068\u5728\u5EAB\u3092\u78BA\u8A8D\u3057\u3001\u9078\u3073\u3084\u3059\u3044\u4FA1\u683C\u5E2F\u306E\u5546\u54C1\u3092\u53B3\u9078\u3057\u307E\u3057\u305F\u3002",
        en: "Compare PCs, monitors, printers, and accessories for classes, job hunting, home projects, and work. Each item was selected after reviewing stock and current retail pricing."
    },
    categories: [
        {
            key: "all",
            label: {
                ja: "\u3059\u3079\u3066",
                en: "All"
            }
        },
        {
            key: "pc",
            label: {
                ja: "\u30D1\u30BD\u30B3\u30F3",
                en: "PCs"
            }
        },
        {
            key: "monitor",
            label: {
                ja: "\u30E2\u30CB\u30BF\u30FC",
                en: "Monitors"
            }
        },
        {
            key: "printer",
            label: {
                ja: "\u30D7\u30EA\u30F3\u30BF\u30FC",
                en: "Printers"
            }
        },
        {
            key: "accessory",
            label: {
                ja: "\u5468\u8FBA\u6A5F\u5668",
                en: "Accessories"
            }
        }
    ],
    searchLabel: {
        ja: "\u5546\u54C1\u3092\u691C\u7D22",
        en: "Search products"
    },
    searchPlaceholder: {
        ja: "\u5546\u54C1\u540D\u30FB\u578B\u756A\u30FB\u7528\u9014\u3067\u691C\u7D22",
        en: "Search by name, model, or use"
    },
    sortLabel: {
        ja: "\u4E26\u3073\u9806",
        en: "Sort"
    },
    sortOptions: [
        {
            key: "recommended",
            label: {
                ja: "\u304A\u3059\u3059\u3081\u9806",
                en: "Recommended"
            }
        },
        {
            key: "price-asc",
            label: {
                ja: "\u4FA1\u683C\u304C\u5B89\u3044\u9806",
                en: "Price: low to high"
            }
        },
        {
            key: "price-desc",
            label: {
                ja: "\u4FA1\u683C\u304C\u9AD8\u3044\u9806",
                en: "Price: high to low"
            }
        }
    ],
    resultLabel: {
        ja: "\u4EF6\u306E\u5546\u54C1",
        en: "products"
    },
    noResults: {
        ja: "\u6761\u4EF6\u306B\u5408\u3046\u5546\u54C1\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u691C\u7D22\u6761\u4EF6\u3092\u5909\u66F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        en: "No products match these filters."
    },
    featuredLabel: {
        ja: "\u304A\u3059\u3059\u3081",
        en: "Featured"
    },
    compareToggle: {
        ja: "\u6BD4\u8F03\u306B\u8FFD\u52A0",
        en: "Add to compare"
    },
    compareSelected: {
        ja: "\u5546\u54C1\u3092\u9078\u629E\u4E2D",
        en: "selected"
    },
    compareOpen: {
        ja: "\u6BD4\u8F03\u8868\u3092\u898B\u308B",
        en: "View comparison"
    },
    compareClear: {
        ja: "\u9078\u629E\u3092\u89E3\u9664",
        en: "Clear"
    },
    compareLimit: {
        ja: "\u6BD4\u8F03\u3067\u304D\u308B\u5546\u54C1\u306F3\u3064\u307E\u3067\u3067\u3059\u3002",
        en: "You can compare up to three products."
    },
    compareTitle: {
        ja: "\u9078\u629E\u3057\u305F\u5546\u54C1\u306E\u6BD4\u8F03",
        en: "Compare selected products"
    },
    compareClose: {
        ja: "\u9589\u3058\u308B",
        en: "Close"
    },
    compareQuote: {
        ja: "\u9078\u629E\u5546\u54C1\u3092\u307E\u3068\u3081\u3066\u76F8\u8AC7",
        en: "Ask about selected products"
    },
    compareRows: {
        category: {
            ja: "\u30AB\u30C6\u30B4\u30EA\u30FC",
            en: "Category"
        },
        price: {
            ja: "\u63B2\u8F09\u4FA1\u683C\uFF08\u7A0E\u8FBC\uFF09",
            en: "Listed price (tax incl.)"
        },
        features: {
            ja: "\u4E3B\u306A\u4ED5\u69D8\u30FB\u7279\u5FB4",
            en: "Key features"
        },
        stock: {
            ja: "\u5728\u5EAB",
            en: "Stock"
        }
    },
    taxIncluded: {
        ja: "\u7A0E\u8FBC",
        en: "tax incl."
    },
    shippingNote: {
        ja: "\u9001\u6599\u5225\u30FB\u8CFC\u5165\u524D\u306B\u3054\u6848\u5185",
        en: "Shipping confirmed before purchase"
    },
    quoteCta: {
        ja: "\u8CFC\u5165\u30FB\u5728\u5EAB\u3092\u554F\u3044\u5408\u308F\u305B",
        en: "Ask about purchase and stock"
    },
    makerCta: {
        ja: "\u88FD\u54C1\u60C5\u5831",
        en: "Product details"
    },
    stockNote: {
        ja: "\u5728\u5EAB\u78BA\u8A8D\u6E08\u307F\uFF082026\u5E748\u67088\u65E5\uFF09",
        en: "Stock checked Aug 8, 2026"
    },
    processLabel: {
        ja: "How it works",
        en: "How it works"
    },
    processTitle: {
        ja: "\u3054\u76F8\u8AC7\u304B\u3089\u304A\u5C4A\u3051\u307E\u3067",
        en: "From inquiry to delivery"
    },
    process: [
        {
            title: {
                ja: "\u5546\u54C1\u3068\u6570\u91CF\u3092\u9001\u4FE1",
                en: "Send product and quantity"
            },
            text: {
                ja: "1\u70B9\u3067\u3082\u8907\u6570\u70B9\u3067\u3082\u3054\u76F8\u8AC7\u53EF\u80FD\u3067\u3059\u3002\u6BD4\u8F03\u6A5F\u80FD\u3067\u5019\u88DC\u3092\u7D5E\u308B\u304B\u3001\u5546\u54C1\u30AB\u30FC\u30C9\u304B\u3089\u6570\u91CF\u30FB\u304A\u5C4A\u3051\u5148\u30FB\u5E0C\u671B\u6642\u671F\u3092\u304A\u77E5\u3089\u305B\u304F\u3060\u3055\u3044\u3002",
                en: "Ask about one item or several. Shortlist products with comparison, then tell us quantity, delivery address, and preferred timing."
            }
        },
        {
            title: {
                ja: "\u5728\u5EAB\u30FB\u9001\u6599\u3092\u78BA\u8A8D",
                en: "We confirm stock and shipping"
            },
            text: {
                ja: "\u6700\u65B0\u306E\u5728\u5EAB\u3001\u7D0D\u671F\u3001\u9001\u6599\u3092\u78BA\u8A8D\u3057\u3001\u3054\u8CFC\u5165\u5185\u5BB9\u3092\u3054\u6848\u5185\u3057\u307E\u3059\u3002\u8907\u6570\u53F0\u306E\u5834\u5408\u306F\u6B63\u5F0F\u306A\u304A\u898B\u7A4D\u66F8\u3082\u767A\u884C\u3057\u307E\u3059\u3002",
                en: "We confirm current stock, lead time, and shipping. A formal quotation is also available for multi-unit orders."
            }
        },
        {
            title: {
                ja: "\u3054\u6CE8\u6587\u30FB\u304A\u5C4A\u3051",
                en: "Order and delivery"
            },
            text: {
                ja: "\u5185\u5BB9\u3092\u3054\u78BA\u8A8D\u3044\u305F\u3060\u3044\u305F\u5F8C\u306B\u5546\u54C1\u3092\u624B\u914D\u3057\u307E\u3059\u3002\u521D\u671F\u8A2D\u5B9A\u3001\u8907\u6570\u53F0\u3001\u5B66\u6821\u30FB\u4E8B\u52D9\u6240\u3078\u306E\u7D0D\u54C1\u3082\u3054\u76F8\u8AC7\u3044\u305F\u3060\u3051\u307E\u3059\u3002",
                en: "We arrange the order after confirmation. Setup, multi-unit orders, and delivery to schools or offices are also available."
            }
        }
    ],
    noticeTitle: {
        ja: "\u4FA1\u683C\u30FB\u3054\u6CE8\u6587\u306B\u3064\u3044\u3066",
        en: "Pricing and orders"
    },
    notices: [
        {
            ja: "\u5B66\u751F\u30FB\u500B\u4EBA\u30FB\u500B\u4EBA\u4E8B\u696D\u4E3B\u30FB\u6CD5\u4EBA\u306E\u304A\u5BA2\u69D8\u306B\u3054\u8CFC\u5165\u3044\u305F\u3060\u3051\u307E\u3059\u3002\u8868\u793A\u4FA1\u683C\u306F1\u53F0\u307E\u305F\u306F1\u500B\u3042\u305F\u308A\u306E\u7A0E\u8FBC\u4FA1\u683C\u3067\u3059\u3002",
            en: "Students, individuals, sole proprietors, and companies can purchase. Prices shown are tax-inclusive per unit."
        },
        {
            ja: "\u5E02\u5834\u4FA1\u683C\u30FB\u4ED5\u5165\u4FA1\u683C\u30FB\u5728\u5EAB\u306F\u5909\u52D5\u3059\u308B\u305F\u3081\u3001\u6B63\u5F0F\u306A\u4FA1\u683C\u3068\u7D0D\u671F\u306F\u3054\u8CFC\u5165\u524D\u306B\u78BA\u5B9A\u3057\u307E\u3059\u3002",
            en: "Market and supply prices and stock change; final price and lead time are confirmed before purchase."
        },
        {
            ja: "\u9001\u6599\u3001\u8A2D\u7F6E\u3001\u521D\u671F\u8A2D\u5B9A\u3001\u5EF6\u9577\u4FDD\u8A3C\u306A\u3069\u306F\u7D0D\u54C1\u6761\u4EF6\u306B\u5FDC\u3058\u3066\u5225\u9014\u304A\u898B\u7A4D\u3057\u307E\u3059\u3002",
            en: "Shipping, installation, setup, and extended warranty are quoted separately as needed."
        },
        {
            ja: "\u5546\u54C1\u753B\u50CF\u306F\u53C2\u8003\u3067\u3059\u3002\u8272\u30FB\u5F62\u72B6\u30FB\u4ED8\u5C5E\u54C1\u306A\u3069\u304C\u5B9F\u969B\u306E\u69CB\u6210\u3068\u7570\u306A\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002",
            en: "Product images are for reference. Color, shape, and included accessories may vary by configuration."
        }
    ],
    ctaTitle: {
        ja: "1\u70B9\u304B\u3089\u8907\u6570\u53F0\u307E\u3067\u3054\u76F8\u8AC7\u304F\u3060\u3055\u3044",
        en: "Ask about one item or a full setup"
    },
    ctaText: {
        ja: "\u6388\u696D\u30FB\u5C31\u6D3B\u30FB\u81EA\u5B85\u4F5C\u696D\u7528\u306E1\u53F0\u304B\u3089\u3001PC\u30FB\u30E2\u30CB\u30BF\u30FC\u30FB\u5468\u8FBA\u6A5F\u5668\u306E\u307E\u3068\u3081\u8CB7\u3044\u3001\u521D\u671F\u8A2D\u5B9A\u3084\u30AF\u30E9\u30A6\u30C9\u5C0E\u5165\u307E\u3067\u5BFE\u5FDC\u3057\u307E\u3059\u3002",
        en: "From one device for classes, job hunting, or home projects to bundled PCs, monitors, accessories, setup, and cloud rollout support."
    },
    ctaBtn: {
        ja: "\u8CFC\u5165\u30FB\u307E\u3068\u3081\u8CB7\u3044\u3092\u76F8\u8AC7",
        en: "Ask about purchase or bundles"
    }
};
const IT_STORE_PRODUCTS = [
    {
        id: "vaio-pro-pg",
        group: "pc",
        type: "laptop",
        theme: "vaio",
        featured: true,
        maker: "VAIO",
        model: "VJPG324000007",
        price: 242000,
        stock: "50",
        name: {
            ja: "VAIO Pro PG",
            en: "VAIO Pro PG"
        },
        category: {
            ja: "13.3\u578B \u30E2\u30D0\u30A4\u30EB\u30CE\u30FC\u30C8PC",
            en: "13.3-inch mobile laptop"
        },
        tagline: {
            ja: "\u7D041.0kg\u3002\u5916\u51FA\u5148\u3067\u3082\u4ED5\u4E8B\u3092\u6B62\u3081\u306A\u3044\u3002",
            en: "About 1.0kg for productive work on the move."
        },
        desc: {
            ja: "Windows 11 Pro\u3001Core 5\u3001\u30E1\u30E2\u30EA16GB\u3092\u7D041.0kg\u306E\u7B50\u4F53\u306B\u642D\u8F09\u3002\u9854\u30FB\u6307\u7D0B\u8A8D\u8A3C\u30683\u5E74\u4FDD\u8A3C\u3092\u5099\u3048\u305F\u6CD5\u4EBA\u5411\u3051\u30E2\u30D0\u30A4\u30EBPC\u3067\u3059\u3002",
            en: "A roughly 1.0kg business laptop with Windows 11 Pro, Core 5, 16GB memory, biometric login, and a three-year warranty."
        },
        makerUrl: "https://vaio.com/business/pg32/spec_std/",
        highlights: [
            {
                ja: "\u7D041.0kg",
                en: "About 1.0kg"
            },
            {
                ja: "Core 5 / 16GB",
                en: "Core 5 / 16GB"
            },
            {
                ja: "SSD 256GB",
                en: "256GB SSD"
            },
            {
                ja: "3\u5E74\u4FDD\u8A3C",
                en: "3-year warranty"
            }
        ]
    },
    {
        id: "vaio-pro-bm",
        group: "pc",
        type: "laptop",
        theme: "vaio",
        featured: true,
        maker: "VAIO",
        model: "VJBM124000007",
        price: 219800,
        stock: "74",
        name: {
            ja: "VAIO Pro BM",
            en: "VAIO Pro BM"
        },
        category: {
            ja: "16\u578B \u30D3\u30B8\u30CD\u30B9\u30CE\u30FC\u30C8PC",
            en: "16-inch business laptop"
        },
        tagline: {
            ja: "\u5927\u304D\u306A\u753B\u9762\u3068\u30013\u5E74\u4FDD\u8A3C\u306E\u5B89\u5FC3\u3092\u3002",
            en: "A larger workspace with a three-year warranty."
        },
        desc: {
            ja: "Windows 11 Pro\u3001Core 5\u3001\u30E1\u30E2\u30EA16GB\u3092\u5099\u3048\u305F\u6CD5\u4EBA\u5411\u3051PC\u3002\u8868\u8A08\u7B97\u3001\u8CC7\u6599\u4F5C\u6210\u3001Web\u4F1A\u8B70\u30921\u53F0\u3067\u5FEB\u9069\u306B\u3053\u306A\u305B\u307E\u3059\u3002",
            en: "A reliable business PC with Windows 11 Pro, Core 5, and 16GB memory for spreadsheets, presentations, and video meetings."
        },
        makerUrl: "https://vaio.com/business/bm12/spec_std/",
        highlights: [
            {
                ja: "Core 5 / 16GB",
                en: "Core 5 / 16GB"
            },
            {
                ja: "SSD 256GB",
                en: "256GB SSD"
            },
            {
                ja: "16\u578B WUXGA",
                en: "16-inch WUXGA"
            },
            {
                ja: "3\u5E74\u4FDD\u8A3C",
                en: "3-year warranty"
            }
        ]
    },
    {
        id: "dell-pro-15-essential",
        group: "pc",
        type: "laptop",
        theme: "dell",
        featured: true,
        maker: "Dell",
        model: "NBLA155-014N1",
        price: 159800,
        stock: "100+",
        name: {
            ja: "Dell Pro 15 Essential",
            en: "Dell Pro 15 Essential"
        },
        category: {
            ja: "15.6\u578B \u30D3\u30B8\u30CD\u30B9\u30CE\u30FC\u30C8PC",
            en: "15.6-inch business laptop"
        },
        tagline: {
            ja: "\u6A19\u6E96\u696D\u52D9\u3092\u3001\u7121\u7406\u306E\u306A\u3044\u4E88\u7B97\u3067\u3002",
            en: "Everyday business performance at a practical price."
        },
        desc: {
            ja: "\u7B2C13\u4E16\u4EE3Core i5\u3001\u30E1\u30E2\u30EA16GB\u3001Windows 11 Pro\u3092\u642D\u8F09\u3002\u30D0\u30C3\u30AF\u30AA\u30D5\u30A3\u30B9\u3084\u62E0\u70B9\u914D\u5099\u306B\u5411\u304F\u30D9\u30FC\u30B7\u30C3\u30AF\u30E2\u30C7\u30EB\u3067\u3059\u3002",
            en: "A practical deployment model with a 13th-gen Core i5, 16GB memory, and Windows 11 Pro."
        },
        makerUrl: "https://www.dell.com/ja-jp/shop/dell-laptops/scr/laptops/appref=dell-pro-essential-product-line",
        highlights: [
            {
                ja: "Core i5 / 16GB",
                en: "Core i5 / 16GB"
            },
            {
                ja: "SSD 256GB",
                en: "256GB SSD"
            },
            {
                ja: "15.6\u578B FHD",
                en: "15.6-inch FHD"
            },
            {
                ja: "Windows 11 Pro",
                en: "Windows 11 Pro"
            }
        ]
    },
    {
        id: "hp-probook-4-g1a",
        group: "pc",
        type: "laptop",
        theme: "hp",
        maker: "HP",
        model: "BT6H7PT-AAAA",
        price: 191800,
        stock: "100+",
        name: {
            ja: "HP ProBook 4 G1a 14",
            en: "HP ProBook 4 G1a 14"
        },
        category: {
            ja: "14\u578B \u30D3\u30B8\u30CD\u30B9\u30CE\u30FC\u30C8PC",
            en: "14-inch business laptop"
        },
        tagline: {
            ja: "\u6301\u3061\u904B\u3073\u3068\u51E6\u7406\u6027\u80FD\u306E\u30D0\u30E9\u30F3\u30B9\u3002",
            en: "Balanced mobility and processing power."
        },
        desc: {
            ja: "Ryzen 7\u3001\u30E1\u30E2\u30EA16GB\u3001SSD 512GB\u3092\u642D\u8F09\u3002\u30AA\u30D5\u30A3\u30B9\u5185\u306E\u79FB\u52D5\u3068\u65E5\u5E38\u696D\u52D9\u306E\u5FEB\u9069\u3055\u3092\u4E21\u7ACB\u3057\u307E\u3059\u3002",
            en: "Ryzen 7, 16GB memory, and a 512GB SSD balance office mobility with responsive daily work."
        },
        makerUrl: "https://jp.ext.hp.com/prod/notebooks/business/hp_probook_4_g1a_14/",
        highlights: [
            {
                ja: "Ryzen 7 / 16GB",
                en: "Ryzen 7 / 16GB"
            },
            {
                ja: "SSD 512GB",
                en: "512GB SSD"
            },
            {
                ja: "14\u578B",
                en: "14-inch"
            },
            {
                ja: "Windows 11 Pro",
                en: "Windows 11 Pro"
            }
        ]
    },
    {
        id: "iodata-lcd-a241db",
        group: "monitor",
        type: "monitor",
        theme: "display",
        featured: true,
        maker: "I-O DATA",
        model: "LCD-A241DB",
        price: 12800,
        stock: "100+",
        name: {
            ja: "LCD-A241DB",
            en: "LCD-A241DB"
        },
        category: {
            ja: "23.8\u578B \u30D5\u30EBHD\u30E2\u30CB\u30BF\u30FC",
            en: "23.8-inch Full HD monitor"
        },
        tagline: {
            ja: "5\u5E74\u4FDD\u8A3C\u3067\u3001\u6A19\u6E96\u5E2D\u3092\u6574\u3048\u308B\u3002",
            en: "A five-year warranty for standard workstations."
        },
        desc: {
            ja: "\u5E83\u8996\u91CE\u89D2ADS\u30D1\u30CD\u30EB\u3068\u30B9\u30D4\u30FC\u30AB\u30FC\u3092\u642D\u8F09\u3057\u305F23.8\u578B\u3002\u8907\u6570\u53F0\u306E\u4E00\u62EC\u5C0E\u5165\u306B\u3082\u5411\u304F\u5B9A\u756A\u30E2\u30CB\u30BF\u30FC\u3067\u3059\u3002",
            en: "A 23.8-inch monitor with a wide-view ADS panel, speakers, and a five-year warranty."
        },
        makerUrl: "https://www.iodata.jp/product/lcd/bizwide/lcd-a241db/",
        highlights: [
            {
                ja: "23.8\u578B FHD",
                en: "23.8-inch FHD"
            },
            {
                ja: "ADS\u30D1\u30CD\u30EB",
                en: "ADS panel"
            },
            {
                ja: "\u30B9\u30D4\u30FC\u30AB\u30FC",
                en: "Speakers"
            },
            {
                ja: "5\u5E74\u4FDD\u8A3C",
                en: "5-year warranty"
            }
        ]
    },
    {
        id: "lg-24ms500-b",
        group: "monitor",
        type: "monitor",
        theme: "display",
        maker: "LG",
        model: "24MS500-B",
        price: 12280,
        stock: "100+",
        name: {
            ja: "24MS500-B",
            en: "24MS500-B"
        },
        category: {
            ja: "23.8\u578B 100Hz IPS\u30E2\u30CB\u30BF\u30FC",
            en: "23.8-inch 100Hz IPS monitor"
        },
        tagline: {
            ja: "\u6ED1\u3089\u304B\u306A\u8868\u793A\u3092\u3001\u65E5\u5E38\u306E\u30C7\u30B9\u30AF\u3078\u3002",
            en: "Smoother everyday work with a 100Hz display."
        },
        desc: {
            ja: "\u30D5\u30EBHD\u306EIPS\u30D1\u30CD\u30EB\u3068100Hz\u8868\u793A\u306B\u5BFE\u5FDC\u3002\u30B9\u30AF\u30ED\u30FC\u30EB\u3084\u753B\u9762\u5207\u308A\u66FF\u3048\u304C\u591A\u3044\u696D\u52D9\u306B\u3082\u6271\u3044\u3084\u3059\u3044\u30E2\u30C7\u30EB\u3067\u3059\u3002",
            en: "A Full HD IPS panel with a 100Hz refresh rate for smooth scrolling and everyday office work."
        },
        makerUrl: "https://www.lg.com/jp/monitors/fhd-qhd/24ms500-b/",
        highlights: [
            {
                ja: "23.8\u578B FHD",
                en: "23.8-inch FHD"
            },
            {
                ja: "IPS\u30D1\u30CD\u30EB",
                en: "IPS panel"
            },
            {
                ja: "100Hz",
                en: "100Hz"
            },
            {
                ja: "HDMI\xd72",
                en: "2\xd7 HDMI"
            }
        ]
    },
    {
        id: "benq-gw2791",
        group: "monitor",
        type: "monitor",
        theme: "display",
        maker: "BenQ",
        model: "GW2791",
        price: 15980,
        stock: "56",
        name: {
            ja: "GW2791",
            en: "GW2791"
        },
        category: {
            ja: "27\u578B \u30A2\u30A4\u30B1\u30A2\u30E2\u30CB\u30BF\u30FC",
            en: "27-inch Eye-Care monitor"
        },
        tagline: {
            ja: "\u8CC7\u6599\u3092\u5E83\u304F\u3001\u76EE\u306B\u3084\u3055\u3057\u304F\u3002",
            en: "More space with eye-comfort features."
        },
        desc: {
            ja: "27\u578B\u306E\u5E83\u3044\u4F5C\u696D\u9818\u57DF\u306B\u3001\u30D6\u30EB\u30FC\u30E9\u30A4\u30C8\u8EFD\u6E1B\u3068\u30D5\u30EA\u30C3\u30AB\u30FC\u30D5\u30EA\u30FC\u3092\u642D\u8F09\u3002\u9577\u6642\u9593\u306E\u30C7\u30B9\u30AF\u30EF\u30FC\u30AF\u306B\u5411\u304D\u307E\u3059\u3002",
            en: "A roomy 27-inch display with low blue light and flicker-free technology for longer desk sessions."
        },
        makerUrl: "https://www.benq.com/ja-jp/monitor/home/gw2791.html",
        highlights: [
            {
                ja: "27\u578B FHD",
                en: "27-inch FHD"
            },
            {
                ja: "\u30A2\u30A4\u30B1\u30A2",
                en: "Eye-Care"
            },
            {
                ja: "\u30CE\u30F3\u30B0\u30EC\u30A2",
                en: "Anti-glare"
            },
            {
                ja: "100Hz",
                en: "100Hz"
            }
        ]
    },
    {
        id: "philips-241s9a",
        group: "monitor",
        type: "monitor",
        theme: "display",
        maker: "Philips",
        model: "241S9A/11",
        price: 12980,
        stock: "100+",
        name: {
            ja: "241S9A/11",
            en: "241S9A/11"
        },
        category: {
            ja: "23.8\u578B \u30D5\u30EBHD\u30E2\u30CB\u30BF\u30FC",
            en: "23.8-inch Full HD monitor"
        },
        tagline: {
            ja: "\u7701\u30B9\u30DA\u30FC\u30B9\u3067\u3001\u898B\u3084\u3059\u3044\u6A19\u6E96\u30B5\u30A4\u30BA\u3002",
            en: "A clear, space-efficient standard display."
        },
        desc: {
            ja: "23.8\u578B\u30D5\u30EBHD\u3001\u30B9\u30D4\u30FC\u30AB\u30FC\u642D\u8F09\u306E\u5B9F\u7528\u30E2\u30C7\u30EB\u3002\u4F1A\u8B70\u5BA4\u3084\u56FA\u5B9A\u5E2D\u3078\u306E\u8FFD\u52A0\u5C0E\u5165\u306B\u3082\u9069\u3057\u3066\u3044\u307E\u3059\u3002",
            en: "A practical 23.8-inch Full HD display with speakers for desks and meeting rooms."
        },
        makerUrl: "https://www.philips.co.jp/c-p/241S9A_11/lcd-monitor",
        highlights: [
            {
                ja: "23.8\u578B FHD",
                en: "23.8-inch FHD"
            },
            {
                ja: "\u30CE\u30F3\u30B0\u30EC\u30A2",
                en: "Anti-glare"
            },
            {
                ja: "\u30B9\u30D4\u30FC\u30AB\u30FC",
                en: "Speakers"
            },
            {
                ja: "5\u5E74\u4FDD\u8A3C",
                en: "5-year warranty"
            }
        ]
    },
    {
        id: "canon-lbp621c",
        group: "printer",
        type: "printer-color",
        theme: "color",
        featured: true,
        maker: "Canon",
        model: "3104C010",
        price: 19800,
        stock: "52",
        name: {
            ja: "Satera LBP621C",
            en: "Satera LBP621C"
        },
        category: {
            ja: "A4 \u30AB\u30E9\u30FC\u30EC\u30FC\u30B6\u30FC\u30D7\u30EA\u30F3\u30BF\u30FC",
            en: "A4 color laser printer"
        },
        tagline: {
            ja: "\u7701\u30B9\u30DA\u30FC\u30B9\u3067\u3001\u8CC7\u6599\u3092\u9BAE\u3084\u304B\u306B\u3002",
            en: "Compact color output for everyday documents."
        },
        desc: {
            ja: "\u30AB\u30E9\u30FC\u30FB\u30E2\u30CE\u30AF\u30ED\u3068\u3082\u9AD8\u901F\u51FA\u529B\u3002\u7121\u7DDALAN\u5BFE\u5FDC\u3067\u7F6E\u304D\u5834\u6240\u3092\u9078\u3073\u306B\u304F\u304F\u3001\u63D0\u6848\u66F8\u3084\u8CA9\u4FC3\u8CC7\u6599\u3092\u793E\u5185\u3067\u5370\u5237\u3067\u304D\u307E\u3059\u3002",
            en: "Fast color and monochrome output with wireless LAN for flexible placement."
        },
        makerUrl: "https://canon.jp/biz/product/printer/satera/lbp/lineup/622c-621c",
        highlights: [
            {
                ja: "A4\u30AB\u30E9\u30FC",
                en: "A4 color"
            },
            {
                ja: "\u7121\u7DDA / \u6709\u7DDALAN",
                en: "Wireless / wired LAN"
            },
            {
                ja: "\u7701\u30B9\u30DA\u30FC\u30B9",
                en: "Compact"
            },
            {
                ja: "\u6BCE\u520618\u679A",
                en: "18 ppm"
            }
        ]
    },
    {
        id: "epson-px-m6011f",
        group: "printer",
        type: "printer-multi",
        theme: "color",
        maker: "EPSON",
        model: "PX-M6011F",
        price: 42800,
        stock: "30",
        name: {
            ja: "PX-M6011F",
            en: "PX-M6011F"
        },
        category: {
            ja: "A3 \u30AB\u30E9\u30FC\u30A4\u30F3\u30AF\u30B8\u30A7\u30C3\u30C8\u8907\u5408\u6A5F",
            en: "A3 color inkjet multifunction printer"
        },
        tagline: {
            ja: "A3\u5BFE\u5FDC\u3092\u3001\u8EAB\u8FD1\u306A\u8907\u5408\u6A5F\u3067\u3002",
            en: "Accessible A3 printing, scanning, copying, and fax."
        },
        desc: {
            ja: "A3\u5370\u5237\u3001\u30B3\u30D4\u30FC\u3001\u30B9\u30AD\u30E3\u30F3\u3001FAX\u306B\u5BFE\u5FDC\u3057\u305F2\u6BB5\u30AB\u30BB\u30C3\u30C8\u30E2\u30C7\u30EB\u3002\u56F3\u9762\u3084\u63B2\u793A\u7269\u3092\u6271\u3046\u5C0F\u898F\u6A21\u30AA\u30D5\u30A3\u30B9\u306B\u5411\u304D\u307E\u3059\u3002",
            en: "A two-tray A3 multifunction model for printing, copying, scanning, and faxing."
        },
        makerUrl: "https://www.epson.jp/products/bizprinter/pxm6011f/",
        highlights: [
            {
                ja: "A3\u5BFE\u5FDC",
                en: "A3 support"
            },
            {
                ja: "2\u6BB5\u30AB\u30BB\u30C3\u30C8",
                en: "Dual trays"
            },
            {
                ja: "\u30B3\u30D4\u30FC / FAX",
                en: "Copy / fax"
            },
            {
                ja: "\u7121\u7DDA / \u6709\u7DDALAN",
                en: "Wireless / wired LAN"
            }
        ]
    },
    {
        id: "canon-mf753cdw",
        group: "printer",
        type: "printer-multi",
        theme: "color",
        maker: "Canon",
        model: "5455C011",
        price: 78900,
        stock: "17",
        name: {
            ja: "Satera MF753Cdw",
            en: "Satera MF753Cdw"
        },
        category: {
            ja: "A4 \u30AB\u30E9\u30FC\u30EC\u30FC\u30B6\u30FC\u8907\u5408\u6A5F",
            en: "A4 color laser multifunction printer"
        },
        tagline: {
            ja: "\u30AB\u30E9\u30FC\u696D\u52D9\u3092\u3001\u4E00\u53F0\u306B\u96C6\u7D04\u3002",
            en: "Consolidate everyday color document workflows."
        },
        desc: {
            ja: "\u30D7\u30EA\u30F3\u30C8\u3001\u30B3\u30D4\u30FC\u3001\u30B9\u30AD\u30E3\u30F3\u3001FAX\u30921\u53F0\u306B\u96C6\u7D04\u3002\u4E21\u9762\u540C\u6642\u8AAD\u53D6ADF\u3068\u5927\u578B\u30BF\u30C3\u30C1\u30D1\u30CD\u30EB\u3092\u5099\u3048\u305F\u696D\u52D9\u5411\u3051\u30E2\u30C7\u30EB\u3067\u3059\u3002",
            en: "Print, copy, scan, and fax with a duplex ADF and a large touchscreen."
        },
        makerUrl: "https://canon.jp/biz/product/printer/satera/mfp/lineup/mf755cdw-mf753cdw",
        highlights: [
            {
                ja: "A4\u30AB\u30E9\u30FC\u8907\u5408\u6A5F",
                en: "A4 color MFP"
            },
            {
                ja: "\u4E21\u9762\u540C\u6642\u8AAD\u53D6",
                en: "Duplex scanning"
            },
            {
                ja: "FAX\u5BFE\u5FDC",
                en: "Fax"
            },
            {
                ja: "\u7121\u7DDA / \u6709\u7DDALAN",
                en: "Wireless / wired LAN"
            }
        ]
    },
    {
        id: "elecom-m-k6urbk",
        group: "accessory",
        type: "mouse",
        theme: "supply",
        maker: "ELECOM",
        model: "M-K6URBK/RS",
        price: 990,
        stock: "100+",
        name: {
            ja: "\u6CD5\u4EBA\u5411\u3051USB\u5149\u5B66\u5F0F\u30DE\u30A6\u30B9",
            en: "Business USB Optical Mouse"
        },
        category: {
            ja: "\u6709\u7DDA\u30DE\u30A6\u30B9",
            en: "Wired mouse"
        },
        tagline: {
            ja: "\u914D\u5099\u3057\u3084\u3059\u3044\u3001\u30B7\u30F3\u30D7\u30EB\u306A\u5B9A\u756A\u3002",
            en: "A simple, deployment-friendly standard mouse."
        },
        desc: {
            ja: "USB\u63A5\u7D9A\u306E3\u30DC\u30BF\u30F3\u5149\u5B66\u5F0F\u30DE\u30A6\u30B9\u3002\u96FB\u6C60\u4EA4\u63DB\u3084\u63A5\u7D9A\u8A2D\u5B9A\u304C\u4E0D\u8981\u3067\u3001\u8907\u6570\u5E2D\u3078\u306E\u4E00\u62EC\u5C0E\u5165\u306B\u3082\u5411\u304D\u307E\u3059\u3002",
            en: "A three-button USB optical mouse with no batteries or pairing required."
        },
        makerUrl: "https://www.elecom.co.jp/products/M-K6URBKRS.html",
        highlights: [
            {
                ja: "USB\u6709\u7DDA",
                en: "Wired USB"
            },
            {
                ja: "3\u30DC\u30BF\u30F3",
                en: "3 buttons"
            },
            {
                ja: "M\u30B5\u30A4\u30BA",
                en: "Medium size"
            },
            {
                ja: "RoHS\u6E96\u62E0",
                en: "RoHS compliant"
            }
        ]
    },
    {
        id: "elecom-m-k7brbk",
        group: "accessory",
        type: "mouse",
        theme: "supply",
        maker: "ELECOM",
        model: "M-K7BRBK/RS",
        price: 2180,
        stock: "100+",
        name: {
            ja: "\u6CD5\u4EBA\u5411\u3051\u9AD8\u8010\u4E45Bluetooth\u30DE\u30A6\u30B9",
            en: "Durable Business Bluetooth Mouse"
        },
        category: {
            ja: "Bluetooth\u30DE\u30A6\u30B9",
            en: "Bluetooth mouse"
        },
        tagline: {
            ja: "\u30B1\u30FC\u30D6\u30EB\u30EC\u30B9\u3068\u30013\u5E74\u4FDD\u8A3C\u3002",
            en: "Cable-free convenience with a three-year warranty."
        },
        desc: {
            ja: "1000\u4E07\u56DE\u306E\u9AD8\u8010\u4E45\u30B9\u30A4\u30C3\u30C1\u30683\u5E74\u4FDD\u8A3C\u3092\u5099\u3048\u305F\u6CD5\u4EBA\u5411\u3051\u30E2\u30C7\u30EB\u3002USB\u30DD\u30FC\u30C8\u3092\u585E\u304C\u305A\u306B\u4F7F\u3048\u307E\u3059\u3002",
            en: "A business model with durable switches, a three-year warranty, and no USB receiver required."
        },
        makerUrl: "https://www.elecom.co.jp/products/M-K7BRBKRS.html",
        highlights: [
            {
                ja: "Bluetooth 4.0",
                en: "Bluetooth 4.0"
            },
            {
                ja: "1000\u4E07\u56DE\u8010\u4E45",
                en: "10M-click durability"
            },
            {
                ja: "3\u5E74\u4FDD\u8A3C",
                en: "3-year warranty"
            },
            {
                ja: "3\u30DC\u30BF\u30F3",
                en: "3 buttons"
            }
        ]
    },
    {
        id: "elecom-esl-404",
        group: "accessory",
        type: "lock",
        theme: "supply",
        maker: "ELECOM",
        model: "ESL-404",
        price: 3180,
        stock: "100+",
        name: {
            ja: "\u30DE\u30EB\u30C1\u5BFE\u5FDC\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30EF\u30A4\u30E4\u30FC\u30ED\u30C3\u30AF",
            en: "Multi-slot Security Cable Lock"
        },
        category: {
            ja: "PC\u76D7\u96E3\u9632\u6B62",
            en: "PC theft prevention"
        },
        tagline: {
            ja: "\u9375\u3092\u5897\u3084\u3055\u305A\u3001\u6301\u3061\u51FA\u3057\u3092\u6291\u6B62\u3002",
            en: "Deter device theft without managing keys."
        },
        desc: {
            ja: "3\u7A2E\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B9\u30ED\u30C3\u30C8\u306B\u5BFE\u5FDC\u3059\u308B4\u6841\u30C0\u30A4\u30E4\u30EB\u5F0F\u3002\u5171\u6709PC\u3084\u53D7\u4ED8\u7AEF\u672B\u306E\u76D7\u96E3\u5BFE\u7B56\u306B\u4F7F\u3048\u307E\u3059\u3002",
            en: "A four-digit combination cable lock supporting three common security slot types."
        },
        makerUrl: "https://www.elecom.co.jp/products/ESL-404.html",
        highlights: [
            {
                ja: "4\u6841\u30C0\u30A4\u30E4\u30EB",
                en: "4-digit dial"
            },
            {
                ja: "3\u30B9\u30ED\u30C3\u30C8\u5BFE\u5FDC",
                en: "3 slot types"
            },
            {
                ja: "\u30AD\u30FC\u4E0D\u8981",
                en: "Keyless"
            },
            {
                ja: "\u30EF\u30A4\u30E4\u30FC\u4E00\u4F53",
                en: "Integrated cable"
            }
        ]
    },
    {
        id: "elecom-ef-pfk156w",
        group: "accessory",
        type: "filter",
        theme: "supply",
        featured: true,
        maker: "ELECOM",
        model: "EF-PFK156W",
        price: 5680,
        stock: "100+",
        name: {
            ja: "\u6297\u83CC\u306E\u305E\u304D\u898B\u9632\u6B62\u30D5\u30A3\u30EB\u30BF\u30FC 15.6\u578B",
            en: "15.6-inch Antibacterial Privacy Filter"
        },
        category: {
            ja: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30D5\u30A3\u30EB\u30BF\u30FC",
            en: "Privacy filter"
        },
        tagline: {
            ja: "\u79FB\u52D5\u4E2D\u3084\u5171\u6709\u7A7A\u9593\u306E\u753B\u9762\u60C5\u5831\u3092\u5B88\u308B\u3002",
            en: "Protect on-screen information in shared spaces."
        },
        desc: {
            ja: "\u5DE6\u53F3\u304B\u3089\u306E\u8996\u7DDA\u3092\u906E\u308A\u3001\u8868\u9762\u306E\u6297\u83CC\u52A0\u5DE5\u306B\u3082\u5BFE\u5FDC\u300215.6\u578B16:9\u30CE\u30FC\u30C8PC\u5411\u3051\u3067\u3059\u3002",
            en: "Limits side viewing and adds an antibacterial surface for 15.6-inch 16:9 laptops."
        },
        makerUrl: "https://www.elecom.co.jp/products/EF-PFK156W.html",
        highlights: [
            {
                ja: "15.6\u578B 16:9",
                en: "15.6-inch 16:9"
            },
            {
                ja: "\u306E\u305E\u304D\u898B\u9632\u6B62",
                en: "Privacy protection"
            },
            {
                ja: "\u6297\u83CC\u52A0\u5DE5",
                en: "Antibacterial"
            },
            {
                ja: "\u4E21\u9762\u5BFE\u5FDC",
                en: "Reversible"
            }
        ]
    },
    {
        id: "elecom-ad-hdmivgabk2",
        group: "accessory",
        type: "adapter",
        theme: "supply",
        maker: "ELECOM",
        model: "AD-HDMIVGABK2",
        price: 1850,
        stock: "100+",
        name: {
            ja: "HDMI-VGA\u5909\u63DB\u30A2\u30C0\u30D7\u30BF\u30FC",
            en: "HDMI-to-VGA Adapter"
        },
        category: {
            ja: "\u6620\u50CF\u5909\u63DB\u30A2\u30C0\u30D7\u30BF\u30FC",
            en: "Video adapter"
        },
        tagline: {
            ja: "\u65B0\u3057\u3044PC\u3092\u3001\u65E2\u5B58\u306E\u8A2D\u5099\u3078\u3002",
            en: "Connect newer PCs to existing display equipment."
        },
        desc: {
            ja: "HDMI\u51FA\u529B\u3092VGA\u5165\u529B\u3078\u5909\u63DB\u3002\u4F1A\u8B70\u5BA4\u306E\u65E2\u5B58\u30D7\u30ED\u30B8\u30A7\u30AF\u30BF\u30FC\u3084\u65E7\u578B\u30E2\u30CB\u30BF\u30FC\u3092\u6D3B\u7528\u3067\u304D\u307E\u3059\u3002",
            en: "Converts HDMI output to VGA for existing projectors and older monitors."
        },
        makerUrl: "https://www.elecom.co.jp/products/AD-HDMIVGABK2.html",
        highlights: [
            {
                ja: "HDMI\u2192VGA",
                en: "HDMI to VGA"
            },
            {
                ja: "\u7D0415cm",
                en: "About 15cm"
            },
            {
                ja: "\u30D0\u30B9\u30D1\u30EF\u30FC",
                en: "Bus powered"
            },
            {
                ja: "RoHS\u6E96\u62E0",
                en: "RoHS compliant"
            }
        ]
    },
    {
        id: "elecom-tk-fcm062bk",
        group: "accessory",
        type: "keyboard",
        theme: "supply",
        maker: "ELECOM",
        model: "TK-FCM062BK",
        price: 1390,
        stock: "100+",
        name: {
            ja: "\u6CD5\u4EBA\u5411\u3051\u9AD8\u8010\u4E45USB\u30AD\u30FC\u30DC\u30FC\u30C9",
            en: "Durable Business USB Keyboard"
        },
        category: {
            ja: "\u6709\u7DDA\u30D5\u30EB\u30AD\u30FC\u30DC\u30FC\u30C9",
            en: "Wired full-size keyboard"
        },
        tagline: {
            ja: "\u30C6\u30F3\u30AD\u30FC\u4ED8\u304D\u306E\u6A19\u6E96\u914D\u5217\u3092\u3001\u5404\u5E2D\u3078\u3002",
            en: "A familiar full layout for every workstation."
        },
        desc: {
            ja: "108\u30AD\u30FC\u65E5\u672C\u8A9E\u914D\u5217\u30681000\u4E07\u56DE\u306E\u9AD8\u8010\u4E45\u30AD\u30FC\u3092\u63A1\u7528\u3002\u30C7\u30B9\u30AF\u30C8\u30C3\u30D7PC\u3084\u56FA\u5B9A\u5E2D\u3078\u306E\u4E00\u62EC\u914D\u5099\u306B\u5411\u304D\u307E\u3059\u3002",
            en: "A 108-key Japanese layout with durable keys for fixed desks and desktop PCs."
        },
        makerUrl: "https://www.elecom.co.jp/products/TK-FCM062BK.html",
        highlights: [
            {
                ja: "USB\u6709\u7DDA",
                en: "Wired USB"
            },
            {
                ja: "108\u30AD\u30FC",
                en: "108 keys"
            },
            {
                ja: "\u30C6\u30F3\u30AD\u30FC\u4ED8\u304D",
                en: "Numeric keypad"
            },
            {
                ja: "1000\u4E07\u56DE\u8010\u4E45",
                en: "10M-keystroke durability"
            }
        ]
    }
];
const createCatalogProduct = ({ id, group, type, theme, maker, model, price, stock = "\u5728\u5EAB\u3042\u308A", featured = false, name, category, tagline, desc, makerUrl, highlights })=>({
        id,
        group,
        type,
        theme,
        maker,
        model,
        price,
        stock,
        featured,
        name: {
            ja: name,
            en: name
        },
        category: {
            ja: category,
            en: category
        },
        tagline: {
            ja: tagline,
            en: tagline
        },
        desc: {
            ja: desc,
            en: desc
        },
        makerUrl,
        highlights: highlights.map((value)=>({
                ja: value,
                en: value
            }))
    });
const IT_STORE_ADDITIONAL_PRODUCTS = [
    createCatalogProduct({
        id: "panasonic-fc6-core-ultra5",
        group: "pc",
        type: "laptop",
        theme: "hp",
        maker: "Panasonic",
        model: "CF-FC6RDAAS",
        price: 314000,
        featured: true,
        name: "Let\u2019s note FC6",
        category: "14\u578B \u6CD5\u4EBA\u5411\u3051\u30E2\u30D0\u30A4\u30EBPC",
        tagline: "\u8EFD\u3055\u3068\u5805\u7262\u6027\u3092\u3001\u6BCE\u65E5\u306E\u6301\u3061\u904B\u3073\u3078\u3002",
        desc: "Core Ultra 5\u300116GB\u30E1\u30E2\u30EA\u3001SSD 512GB\u3092\u642D\u8F09\u3002\u793E\u5185\u5916\u3092\u79FB\u52D5\u3059\u308B\u62C5\u5F53\u8005\u306B\u5411\u304F\u6CD5\u4EBA\u5411\u3051\u30E2\u30D0\u30A4\u30EBPC\u3067\u3059\u3002",
        makerUrl: "https://connect.panasonic.com/jp-ja/products-services/letsnote/lineup/fc",
        highlights: [
            "Core Ultra 5",
            "16GB / 512GB",
            "14\u578B",
            "Windows 11 Pro"
        ]
    }),
    createCatalogProduct({
        id: "panasonic-fc6-core-ultra7",
        group: "pc",
        type: "laptop",
        theme: "hp",
        maker: "Panasonic",
        model: "CF-FC6RD7AS",
        price: 331000,
        name: "Let\u2019s note FC6",
        category: "14\u578B \u9AD8\u6027\u80FD\u30E2\u30D0\u30A4\u30EBPC",
        tagline: "\u91CD\u3044\u696D\u52D9\u3082\u6301\u3061\u6B69\u3051\u308B\u4E0A\u4F4D\u69CB\u6210\u3002",
        desc: "Core Ultra 7\u306816GB\u30E1\u30E2\u30EA\u3092\u5099\u3048\u3001\u8CC7\u6599\u4F5C\u6210\u3084Web\u4F1A\u8B70\u3092\u4E26\u884C\u3059\u308B\u696D\u52D9\u306B\u3082\u4F59\u88D5\u3092\u6301\u305F\u305B\u305F\u30E2\u30C7\u30EB\u3067\u3059\u3002",
        makerUrl: "https://connect.panasonic.com/jp-ja/products-services/letsnote/lineup/fc",
        highlights: [
            "Core Ultra 7",
            "16GB / 512GB",
            "14\u578B",
            "Windows 11 Pro"
        ]
    }),
    createCatalogProduct({
        id: "panasonic-sc6",
        group: "pc",
        type: "laptop",
        theme: "hp",
        maker: "Panasonic",
        model: "CF-SC6RDAAS",
        price: 309000,
        name: "Let\u2019s note SC6",
        category: "12.4\u578B \u6CD5\u4EBA\u5411\u3051\u30E2\u30D0\u30A4\u30EBPC",
        tagline: "\u5C0F\u3055\u306A\u30D5\u30C3\u30C8\u30D7\u30EA\u30F3\u30C8\u3067\u3001\u6A5F\u52D5\u529B\u3092\u9AD8\u3081\u308B\u3002",
        desc: "12.4\u578B\u306E\u643A\u5E2F\u6027\u3068Core Ultra 5\u300116GB\u30E1\u30E2\u30EA\u3092\u4E21\u7ACB\u3002\u5916\u51FA\u3084\u51FA\u5F35\u304C\u591A\u3044\u696D\u52D9\u306B\u9069\u3057\u3066\u3044\u307E\u3059\u3002",
        makerUrl: "https://connect.panasonic.com/jp-ja/products-services/letsnote/lineup/sc",
        highlights: [
            "12.4\u578B",
            "Core Ultra 5",
            "16GB / 512GB",
            "Windows 11 Pro"
        ]
    }),
    createCatalogProduct({
        id: "dell-pro-14-plus",
        group: "pc",
        type: "laptop",
        theme: "dell",
        maker: "Dell",
        model: "NBLA150-012H1",
        price: 280000,
        featured: true,
        name: "Dell Pro 14 Plus",
        category: "14\u578B \u9AD8\u6027\u80FD\u30D3\u30B8\u30CD\u30B9PC",
        tagline: "\u51E6\u7406\u6027\u80FD\u3068\u6301\u3061\u904B\u3073\u3092\u4E00\u53F0\u3067\u3002",
        desc: "\u8907\u6570\u30A2\u30D7\u30EA\u3092\u4F7F\u3046\u65E5\u5E38\u696D\u52D9\u3084\u30AA\u30F3\u30E9\u30A4\u30F3\u4F1A\u8B70\u306B\u5411\u304F14\u578B\u6CD5\u4EBA\u30E2\u30C7\u30EB\u3002\u62E0\u70B9\u914D\u5099\u306B\u3082\u500B\u5225\u5C0E\u5165\u306B\u3082\u5BFE\u5FDC\u3057\u307E\u3059\u3002",
        makerUrl: "https://www.dell.com/ja-jp/shop/dell-laptops-and-2-in-1-pcs/scr/laptops/appref=dell-pro-plus-product-line",
        highlights: [
            "14\u578B",
            "Windows 11 Pro",
            "\u6CD5\u4EBA\u5411\u3051",
            "\u6301\u3061\u904B\u3073\u5BFE\u5FDC"
        ]
    }),
    createCatalogProduct({
        id: "dmm-dks-4k43dg6",
        group: "monitor",
        type: "monitor",
        theme: "display",
        maker: "DMM.make",
        model: "DKS-4K43DG6",
        price: 40500,
        featured: true,
        name: "DMM.make 43\u578B 4K\u30E2\u30CB\u30BF\u30FC",
        category: "43\u578B 4K\u30C7\u30A3\u30B9\u30D7\u30EC\u30A4",
        tagline: "\u4F1A\u8B70\u5BA4\u3084\u30B5\u30A4\u30CD\u30FC\u30B8\u306B\u3001\u5927\u753B\u97624K\u3002",
        desc: "43\u578B\u30FB4K\u89E3\u50CF\u5EA6\u3067\u3001\u4F1A\u8B70\u8CC7\u6599\u3084\u6848\u5185\u8868\u793A\u3092\u5927\u304D\u304F\u898B\u305B\u305F\u3044\u74B0\u5883\u306B\u5411\u304F\u30C7\u30A3\u30B9\u30D7\u30EC\u30A4\u3067\u3059\u3002",
        makerUrl: "https://distribution.dmm.com/monitor/",
        highlights: [
            "43\u578B",
            "4K",
            "HDMI",
            "\u4F1A\u8B70\u5BA4\u30FB\u8868\u793A\u7528\u9014"
        ]
    }),
    createCatalogProduct({
        id: "hp-series3-322pf",
        group: "monitor",
        type: "monitor",
        theme: "display",
        maker: "HP",
        model: "9U5B0UT#ABJ",
        price: 11900,
        name: "HP Series 3 Pro 322pf",
        category: "21.5\u578B \u30D5\u30EBHD\u30E2\u30CB\u30BF\u30FC",
        tagline: "\u7701\u30B9\u30DA\u30FC\u30B9\u306A\u6A19\u6E96\u5E2D\u3092\u3001\u624B\u9803\u306B\u3002",
        desc: "21.5\u578B\u30D5\u30EBHD\u306E\u6CD5\u4EBA\u5411\u3051\u30E2\u30CB\u30BF\u30FC\u3002\u53D7\u4ED8\u3001\u56FA\u5B9A\u5E2D\u3001\u30B5\u30D6\u30C7\u30A3\u30B9\u30D7\u30EC\u30A4\u3078\u306E\u8FFD\u52A0\u5C0E\u5165\u306B\u5411\u304D\u307E\u3059\u3002",
        makerUrl: "https://jp.ext.hp.com/monitors/business/",
        highlights: [
            "21.5\u578B FHD",
            "\u975E\u5149\u6CA2",
            "HDMI",
            "VESA\u5BFE\u5FDC"
        ]
    }),
    createCatalogProduct({
        id: "hp-series3-324pv",
        group: "monitor",
        type: "monitor",
        theme: "display",
        maker: "HP",
        model: "9U5C1AA#ABJ",
        price: 11650,
        name: "HP Series 3 Pro 324pv",
        category: "23.8\u578B \u30D5\u30EBHD\u30E2\u30CB\u30BF\u30FC",
        tagline: "\u65E5\u5E38\u696D\u52D9\u306E\u6A19\u6E96\u30B5\u30A4\u30BA\u3092\u4F4E\u30B3\u30B9\u30C8\u3067\u3002",
        desc: "23.8\u578B\u30D5\u30EBHD\u306EVA\u30D1\u30CD\u30EB\u3092\u63A1\u7528\u3002\u8CC7\u6599\u4F5C\u6210\u3084Web\u696D\u52D9\u7528\u306E\u6A19\u6E96\u30E2\u30CB\u30BF\u30FC\u3068\u3057\u3066\u5C0E\u5165\u3057\u3084\u3059\u3044\u69CB\u6210\u3067\u3059\u3002",
        makerUrl: "https://jp.ext.hp.com/monitors/business/",
        highlights: [
            "23.8\u578B FHD",
            "VA\u30D1\u30CD\u30EB",
            "HDMI",
            "3\u5E74\u4FDD\u8A3C"
        ]
    }),
    createCatalogProduct({
        id: "hp-series3-324pf",
        group: "monitor",
        type: "monitor",
        theme: "display",
        maker: "HP",
        model: "9U5J5UT#ABJ",
        price: 14900,
        name: "HP Series 3 Pro 324pf",
        category: "23.8\u578B \u30D5\u30EBHD\u30E2\u30CB\u30BF\u30FC",
        tagline: "\u63A5\u7D9A\u7AEF\u5B50\u3092\u63C3\u3048\u305F\u6CD5\u4EBA\u5411\u3051\u6A19\u6E96\u30E2\u30C7\u30EB\u3002",
        desc: "HDMI\u3001DisplayPort\u3001VGA\u306B\u5BFE\u5FDC\u3059\u308B23.8\u578B\u3002\u65E2\u5B58PC\u3068\u65B0\u3057\u3044PC\u304C\u6DF7\u5728\u3059\u308B\u30AA\u30D5\u30A3\u30B9\u306B\u3082\u5C0E\u5165\u3057\u3084\u3059\u3044\u30E2\u30C7\u30EB\u3067\u3059\u3002",
        makerUrl: "https://jp.ext.hp.com/monitors/business/",
        highlights: [
            "23.8\u578B FHD",
            "HDMI / DP / VGA",
            "\u975E\u5149\u6CA2",
            "\u6CD5\u4EBA\u5411\u3051"
        ]
    }),
    createCatalogProduct({
        id: "iodata-lcd-a241dw",
        group: "monitor",
        type: "monitor",
        theme: "display",
        maker: "I-O DATA",
        model: "LCD-A241DW",
        price: 13580,
        name: "LCD-A241DW",
        category: "23.8\u578B \u30D5\u30EBHD\u30E2\u30CB\u30BF\u30FC",
        tagline: "\u660E\u308B\u3044\u30C7\u30B9\u30AF\u306B\u99B4\u67D3\u3080\u30DB\u30EF\u30A4\u30C8\u30E2\u30C7\u30EB\u3002",
        desc: "\u5E83\u8996\u91CE\u89D2ADS\u30D1\u30CD\u30EB\u3068\u30B9\u30D4\u30FC\u30AB\u30FC\u3092\u642D\u8F09\u3002\u53D7\u4ED8\u3084\u660E\u308B\u3044\u5185\u88C5\u306E\u30AA\u30D5\u30A3\u30B9\u306B\u3082\u5408\u308F\u305B\u3084\u3059\u3044\u30DB\u30EF\u30A4\u30C8\u7B50\u4F53\u3067\u3059\u3002",
        makerUrl: "https://www.iodata.jp/product/lcd/bizwide/lcd-a241db/",
        highlights: [
            "23.8\u578B FHD",
            "ADS\u30D1\u30CD\u30EB",
            "\u30B9\u30D4\u30FC\u30AB\u30FC",
            "5\u5E74\u4FDD\u8A3C"
        ]
    }),
    createCatalogProduct({
        id: "oki-c835dnw",
        group: "printer",
        type: "printer-color",
        theme: "color",
        maker: "OKI",
        model: "C835DNW",
        price: 93900,
        featured: true,
        name: "COREFIDO EX C835dnw",
        category: "A3 \u30AB\u30E9\u30FCLED\u30D7\u30EA\u30F3\u30BF\u30FC",
        tagline: "A3\u30AB\u30E9\u30FC\u3092\u3001\u9AD8\u901F\u30FB\u9AD8\u8010\u4E45\u3067\u3002",
        desc: "\u30AB\u30E9\u30FC\u30FB\u30E2\u30CE\u30AF\u30ED\u7D0435\u679A/\u5206\u306EA3\u5BFE\u5FDC\u6A5F\u3002\u63D0\u6848\u8CC7\u6599\u3001\u56F3\u9762\u3001\u63B2\u793A\u7269\u3092\u793E\u5185\u3067\u591A\u304F\u51FA\u529B\u3059\u308B\u696D\u52D9\u306B\u5411\u304D\u307E\u3059\u3002",
        makerUrl: "https://www.oki.com/jp/printing/products/color/c835dnw/",
        highlights: [
            "A3\u30AB\u30E9\u30FC",
            "\u7121\u7DDA / \u6709\u7DDALAN",
            "\u81EA\u52D5\u4E21\u9762",
            "\u9AD8\u8010\u4E45"
        ]
    }),
    createCatalogProduct({
        id: "elecom-cac-dp1215",
        group: "accessory",
        type: "adapter",
        theme: "supply",
        maker: "ELECOM",
        model: "CAC-DP1215BK",
        price: 2190,
        name: "DisplayPort\u30B1\u30FC\u30D6\u30EB 1.5m",
        category: "\u6620\u50CF\u30B1\u30FC\u30D6\u30EB",
        tagline: "PC\u3068\u30E2\u30CB\u30BF\u30FC\u3092\u5B89\u5B9A\u3057\u3066\u63A5\u7D9A\u3002",
        desc: "DisplayPort\u7AEF\u5B50\u3092\u6301\u3064PC\u3068\u30E2\u30CB\u30BF\u30FC\u306E\u63A5\u7D9A\u306B\u4F7F\u3048\u308B1.5m\u30B1\u30FC\u30D6\u30EB\u3002\u6A19\u6E96\u5E2D\u306E\u914D\u7DDA\u306B\u6271\u3044\u3084\u3059\u3044\u9577\u3055\u3067\u3059\u3002",
        makerUrl: "https://www.elecom.co.jp/products/CAC-DP1215BK.html",
        highlights: [
            "DisplayPort",
            "1.5m",
            "4K\u5BFE\u5FDC",
            "\u30D6\u30E9\u30C3\u30AF"
        ]
    }),
    createCatalogProduct({
        id: "elecom-cac-dp1250",
        group: "accessory",
        type: "adapter",
        theme: "supply",
        maker: "ELECOM",
        model: "CAC-DP1250BK",
        price: 5950,
        name: "DisplayPort\u30B1\u30FC\u30D6\u30EB 5m",
        category: "\u9577\u5C3A\u6620\u50CF\u30B1\u30FC\u30D6\u30EB",
        tagline: "\u4F1A\u8B70\u5BA4\u3084\u96E2\u308C\u305F\u6A5F\u5668\u3092\u9577\u5C3A\u3067\u63A5\u7D9A\u3002",
        desc: "5m\u306EDisplayPort\u30B1\u30FC\u30D6\u30EB\u3002\u4F1A\u8B70\u5BA4\u3001\u53D7\u4ED8\u3001\u58C1\u9762\u30E2\u30CB\u30BF\u30FC\u306A\u3069\u6A5F\u5668\u9593\u306B\u8DDD\u96E2\u304C\u3042\u308B\u914D\u7DDA\u306B\u5411\u304D\u307E\u3059\u3002",
        makerUrl: "https://www.elecom.co.jp/products/CAC-DP1250BK.html",
        highlights: [
            "DisplayPort",
            "5m",
            "4K\u5BFE\u5FDC",
            "\u9577\u5C3A\u914D\u7DDA"
        ]
    }),
    createCatalogProduct({
        id: "elecom-dh-hd14el10",
        group: "accessory",
        type: "adapter",
        theme: "supply",
        maker: "ELECOM",
        model: "DH-HD14EL10/RS",
        price: 660,
        name: "HDMI\u30B1\u30FC\u30D6\u30EB 1m",
        category: "HDMI\u30B1\u30FC\u30D6\u30EB",
        tagline: "\u30C7\u30B9\u30AF\u4E0A\u306E\u77ED\u8DDD\u96E2\u63A5\u7D9A\u3092\u3059\u3063\u304D\u308A\u3002",
        desc: "PC\u3001\u30E2\u30CB\u30BF\u30FC\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30BF\u30FC\u3092\u63A5\u7D9A\u3059\u308B1m\u306EHDMI\u30B1\u30FC\u30D6\u30EB\u3002\u5E2D\u3054\u3068\u306E\u8FFD\u52A0\u914D\u5099\u306B\u3082\u5411\u304D\u307E\u3059\u3002",
        makerUrl: "https://www.elecom.co.jp/products/DH-HD14EL10RS.html",
        highlights: [
            "HDMI",
            "1m",
            "4K\u5BFE\u5FDC",
            "\u7C21\u6613\u30D1\u30C3\u30B1\u30FC\u30B8"
        ]
    }),
    createCatalogProduct({
        id: "elecom-dh-hd14el15",
        group: "accessory",
        type: "adapter",
        theme: "supply",
        maker: "ELECOM",
        model: "DH-HD14EL15/RS",
        price: 740,
        name: "HDMI\u30B1\u30FC\u30D6\u30EB 1.5m",
        category: "HDMI\u30B1\u30FC\u30D6\u30EB",
        tagline: "\u6A19\u6E96\u5E2D\u3084\u4F1A\u8B70\u5BA4\u3067\u4F7F\u3044\u3084\u3059\u3044\u9577\u3055\u3002",
        desc: "1.5m\u306EHDMI\u30B1\u30FC\u30D6\u30EB\u3002\u30CE\u30FC\u30C8PC\u3068\u30E2\u30CB\u30BF\u30FC\u3001\u4F1A\u8B70\u7528PC\u3068\u30C7\u30A3\u30B9\u30D7\u30EC\u30A4\u306E\u63A5\u7D9A\u306B\u4F7F\u3048\u307E\u3059\u3002",
        makerUrl: "https://www.elecom.co.jp/products/DH-HD14EL15RS.html",
        highlights: [
            "HDMI",
            "1.5m",
            "4K\u5BFE\u5FDC",
            "\u7C21\u6613\u30D1\u30C3\u30B1\u30FC\u30B8"
        ]
    }),
    createCatalogProduct({
        id: "elecom-usb4-cc5p08",
        group: "accessory",
        type: "adapter",
        theme: "supply",
        maker: "ELECOM",
        model: "USB4-CC5P08BK",
        price: 3790,
        featured: true,
        name: "USB4 Type-C\u30B1\u30FC\u30D6\u30EB 0.8m",
        category: "\u9AD8\u901FUSB-C\u30B1\u30FC\u30D6\u30EB",
        tagline: "\u6620\u50CF\u30FB\u30C7\u30FC\u30BF\u30FB\u7D66\u96FB\u3092\u4E00\u672C\u306B\u3002",
        desc: "USB4\u5BFE\u5FDC\u306EType-C\u30B1\u30FC\u30D6\u30EB\u3002\u5BFE\u5FDC\u6A5F\u5668\u9593\u306E\u9AD8\u901F\u30C7\u30FC\u30BF\u8EE2\u9001\u3001\u6620\u50CF\u51FA\u529B\u3001USB PD\u7D66\u96FB\u306B\u4F7F\u3048\u307E\u3059\u3002",
        makerUrl: "https://www.elecom.co.jp/products/USB4-CC5P08BK.html",
        highlights: [
            "USB4",
            "\u6700\u592740Gbps",
            "USB PD",
            "0.8m"
        ]
    }),
    createCatalogProduct({
        id: "elecom-dh-hd14el30",
        group: "accessory",
        type: "adapter",
        theme: "supply",
        maker: "ELECOM",
        model: "DH-HD14EL30/RS",
        price: 1290,
        name: "HDMI\u30B1\u30FC\u30D6\u30EB 3m",
        category: "HDMI\u30B1\u30FC\u30D6\u30EB",
        tagline: "\u5C11\u3057\u96E2\u308C\u305F\u4F1A\u8B70\u6A5F\u5668\u306B\u3082\u5C4A\u304F3m\u3002",
        desc: "3m\u306EHDMI\u30B1\u30FC\u30D6\u30EB\u3002\u4F1A\u8B70\u673A\u304B\u3089\u58C1\u9762\u30C7\u30A3\u30B9\u30D7\u30EC\u30A4\u307E\u3067\u306A\u3069\u3001\u4F59\u88D5\u3092\u6301\u305F\u305B\u305F\u3044\u914D\u7DDA\u306B\u5411\u304D\u307E\u3059\u3002",
        makerUrl: "https://www.elecom.co.jp/products/DH-HD14EL30RS.html",
        highlights: [
            "HDMI",
            "3m",
            "4K\u5BFE\u5FDC",
            "\u4F1A\u8B70\u5BA4\u5411\u3051"
        ]
    }),
    createCatalogProduct({
        id: "elecom-dh-hd14el50",
        group: "accessory",
        type: "adapter",
        theme: "supply",
        maker: "ELECOM",
        model: "DH-HD14EL50/RS",
        price: 1240,
        name: "HDMI\u30B1\u30FC\u30D6\u30EB 5m",
        category: "\u9577\u5C3AHDMI\u30B1\u30FC\u30D6\u30EB",
        tagline: "\u96E2\u308C\u305F\u30C7\u30A3\u30B9\u30D7\u30EC\u30A4\u307E\u3067\u4E00\u672C\u3067\u63A5\u7D9A\u3002",
        desc: "5m\u306EHDMI\u30B1\u30FC\u30D6\u30EB\u3002\u58C1\u9762\u30E2\u30CB\u30BF\u30FC\u3084\u30D7\u30ED\u30B8\u30A7\u30AF\u30BF\u30FC\u306A\u3069\u3001\u8DDD\u96E2\u304C\u3042\u308B\u6A5F\u5668\u3078\u306E\u914D\u7DDA\u306B\u4F7F\u3048\u307E\u3059\u3002",
        makerUrl: "https://www.elecom.co.jp/products/DH-HD14EL50RS.html",
        highlights: [
            "HDMI",
            "5m",
            "4K\u5BFE\u5FDC",
            "\u9577\u5C3A\u914D\u7DDA"
        ]
    }),
    createCatalogProduct({
        id: "elecom-usb-ecoea20",
        group: "accessory",
        type: "adapter",
        theme: "supply",
        maker: "ELECOM",
        model: "USB-ECOEA20",
        price: 960,
        name: "USB2.0\u5EF6\u9577\u30B1\u30FC\u30D6\u30EB 2m",
        category: "USB\u5EF6\u9577\u30B1\u30FC\u30D6\u30EB",
        tagline: "USB\u6A5F\u5668\u306E\u7F6E\u304D\u5834\u6240\u3092\u3001\u3082\u3046\u5C11\u3057\u81EA\u7531\u306B\u3002",
        desc: "USB Type-A\u30922m\u5EF6\u9577\u3067\u304D\u308B\u30B1\u30FC\u30D6\u30EB\u3002\u30D7\u30EA\u30F3\u30BF\u30FC\u3001Web\u30AB\u30E1\u30E9\u3001USB\u30CF\u30D6\u306A\u3069\u306E\u914D\u7F6E\u8ABF\u6574\u306B\u4F7F\u3048\u307E\u3059\u3002",
        makerUrl: "https://www.elecom.co.jp/products/USB-ECOEA20.html",
        highlights: [
            "USB2.0",
            "2m",
            "Type-A\u5EF6\u9577",
            "RoHS\u6E96\u62E0"
        ]
    }),
    createCatalogProduct({
        id: "elecom-cac-15",
        group: "accessory",
        type: "adapter",
        theme: "supply",
        maker: "ELECOM",
        model: "CAC-15BK/RS",
        price: 1460,
        name: "VGA\u30C7\u30A3\u30B9\u30D7\u30EC\u30A4\u30B1\u30FC\u30D6\u30EB 1.5m",
        category: "\u6620\u50CF\u30B1\u30FC\u30D6\u30EB",
        tagline: "\u65E2\u5B58\u30E2\u30CB\u30BF\u30FC\u3084\u30D7\u30ED\u30B8\u30A7\u30AF\u30BF\u30FC\u3092\u6D3B\u7528\u3002",
        desc: "VGA\u7AEF\u5B50\u3092\u6301\u3064PC\u3001\u30E2\u30CB\u30BF\u30FC\u3001\u30D7\u30ED\u30B8\u30A7\u30AF\u30BF\u30FC\u3092\u63A5\u7D9A\u3059\u308B1.5m\u30B1\u30FC\u30D6\u30EB\u3002\u65E2\u5B58\u8A2D\u5099\u306E\u5EF6\u547D\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002",
        makerUrl: "https://www.elecom.co.jp/products/CAC-15BKRS.html",
        highlights: [
            "VGA",
            "1.5m",
            "\u30B9\u30EA\u30E0",
            "RoHS\u6E96\u62E0"
        ]
    })
];
const IT_STORE_PRODUCT_IMAGES = {
    "vaio-pro-pg": "assets/it-store-products/vaio-pro-pg.jpg",
    "vaio-pro-bm": "assets/it-store-products/vaio-pro-bm.jpg",
    "dell-pro-15-essential": "assets/it-store-products/dell-pro-15-essential.jpg",
    "hp-probook-4-g1a": "assets/it-store-products/hp-probook-4-g1a.jpg",
    "iodata-lcd-a241db": "assets/it-store-products/iodata-lcd-a241db.jpg",
    "lg-24ms500-b": "assets/it-store-products/lg-24ms500-b.jpg",
    "benq-gw2791": "assets/it-store-products/benq-gw2791.jpg",
    "philips-241s9a": "assets/it-store-products/philips-241s9a.jpg",
    "canon-lbp621c": "assets/it-store-products/canon-lbp621c.jpg",
    "epson-px-m6011f": "assets/it-store-products/epson-px-m6011f.jpg",
    "canon-mf753cdw": "assets/it-store-products/canon-mf753cdw.jpg",
    "elecom-m-k6urbk": "assets/it-store-products/elecom-m-k6urbk.jpg",
    "elecom-m-k7brbk": "assets/it-store-products/elecom-m-k7brbk.jpg",
    "elecom-esl-404": "assets/it-store-products/elecom-esl-404.jpg",
    "elecom-ef-pfk156w": "assets/it-store-products/elecom-ef-pfk156w.jpg",
    "elecom-ad-hdmivgabk2": "assets/it-store-products/elecom-ad-hdmivgabk2.jpg",
    "elecom-tk-fcm062bk": "assets/it-store-products/elecom-tk-fcm062bk.jpg",
    "panasonic-fc6-core-ultra5": "assets/it-store-products/panasonic-fc6.jpg",
    "panasonic-fc6-core-ultra7": "assets/it-store-products/panasonic-fc6.jpg",
    "panasonic-sc6": "assets/it-store-products/panasonic-sc6.jpg",
    "dell-pro-14-plus": "assets/it-store-products/dell-pro-14-plus.jpg",
    "dmm-dks-4k43dg6": "assets/it-store-products/dmm-dks-4k43dg6.jpg",
    "hp-series3-322pf": "assets/it-store-products/hp-series3-322pf.jpg",
    "hp-series3-324pv": "assets/it-store-products/hp-series3-324pv.jpg",
    "hp-series3-324pf": "assets/it-store-products/hp-series3-324pf.jpg",
    "iodata-lcd-a241dw": "assets/it-store-products/iodata-lcd-a241dw.jpg",
    "oki-c835dnw": "assets/it-store-products/oki-c835dnw.jpg",
    "elecom-cac-dp1215": "assets/it-store-products/elecom-cac-dp1215.jpg",
    "elecom-cac-dp1250": "assets/it-store-products/elecom-cac-dp1250.jpg",
    "elecom-dh-hd14el10": "assets/it-store-products/elecom-dh-hd14el10.jpg",
    "elecom-dh-hd14el15": "assets/it-store-products/elecom-dh-hd14el15.jpg",
    "elecom-usb4-cc5p08": "assets/it-store-products/elecom-usb4-cc5p08.jpg",
    "elecom-dh-hd14el30": "assets/it-store-products/elecom-dh-hd14el30.jpg",
    "elecom-dh-hd14el50": "assets/it-store-products/elecom-dh-hd14el50.jpg",
    "elecom-usb-ecoea20": "assets/it-store-products/elecom-usb-ecoea20.jpg",
    "elecom-cac-15": "assets/it-store-products/elecom-cac-15.jpg"
};
function getItStoreProducts() {
    return [
        ...IT_STORE_PRODUCTS,
        ...IT_STORE_ADDITIONAL_PRODUCTS
    ].map((product)=>({
            ...product,
            imageUrl: IT_STORE_PRODUCT_IMAGES[product.id] || ""
        }));
}

//# sourceMappingURL=it-store.10332c54.js.map
